// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2HdwM","fileBtn":"File_fileBtn__6YetM","closeBtn":"File_closeBtn__2oW6s","fileSelected":"File_fileSelected__2JTiF","disabled":"File_disabled__vOdg4"};